import { render, staticRenderFns } from "./user-diagnosis.vue?vue&type=template&id=c621c088"
import script from "./user-diagnosis.vue?vue&type=script&lang=js"
export * from "./user-diagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports